import portalConfiguration from "../../shared/configuration/PortalConfiguration";
import FileHelper from "../../shared/helper/FileHelper";
import JSZip from "jszip";
import {SessionToken} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../../shared/helper/FunctionHelper";

const urlCreator = FunctionHelper.applyValue(window.URL, window.webkitURL);

export default class Downloader {
	private token: SessionToken | undefined;

	constructor(token?: SessionToken) {
		this.token = token;
	}

	public async downloadDocument(id: string, name: string) {
		await FileHelper.download([this.prepareDownloadFile(id, name)]);
	}

	public async downloadDocuments(documents: Array<{ name: string, extension?: string, data: any }>): Promise<void> {
		if (documents.length === 0) {
			return;
		}

		let zipFile: JSZip = new JSZip();

		for (let document of documents) {
			let extension: string = FunctionHelper.exists(document.extension) ? "." + document.extension : "";
			let filename = document.name + extension;

			if (zipFile.file(filename) === null) {
				zipFile.file(filename, document.data);
			} else {
				let count = 1;
				while (true) {
					filename = document.name + "(" + count + ")" + extension;

					if (zipFile.file(filename) === null) {
						zipFile.file(filename, document.data);
						break;
					}

					count++;
				}
			}
		}

		await this.download(await zipFile.generateAsync({type: "blob"}), "Dateien.zip");
	}

	/**
	 * prepares a Portal document for downloading
	 */
	private prepareDownloadFile(id: string, name: string): { name: string, url: string } {
		let url: URL = portalConfiguration.baseUrl;
		url.pathname += "rest/documents/" + id;

		let params: URLSearchParams = new URLSearchParams();
		params.append('cache', new Date().getTime().toString());
		params.append('Token', this.token!.token!);
		url.search += params.toString();

		return {
			name: name,
			url: url.toString()
		}
	}

	public async downloadData(data: BlobPart, filename: string, contentType: string): Promise<any> {
		let fileBlob: Blob = new Blob([data], {type: contentType});

		if (FunctionHelper.exists(urlCreator.createObjectURL)) {
			let blobUrl: string = urlCreator.createObjectURL(fileBlob);
			await FileHelper.download(
				[{name: FunctionHelper.applyValue(filename, "unknown"), url: blobUrl}]
			);
			urlCreator.revokeObjectURL(blobUrl);
		}
	}

	public async download(blob: Blob, filename: string): Promise<any> {
		if (FunctionHelper.exists(urlCreator.createObjectURL)) {
			let blobUrl: string = urlCreator.createObjectURL(blob);
			await FileHelper.download(
				[{name: FunctionHelper.applyValue(filename, "unknown"), url: blobUrl}]
			);
			urlCreator.revokeObjectURL(blobUrl);
		}
	}
}